import ClosingCostList from "./ClosingCostList";

export default ClosingCostList;